import GenericObject from '@/Model/GenericObject';
import { IPDIteratorOperatorDTO } from "coreframetypings/dto";

export default class IteratorHelper {

    /**
     * Erzeugt einen IteratorOperator mit Standardeinstellungen.
     * @param genericObject - optional - Enthält das GenericObject historische Informationen werden diese gesetzt
     */
    public static getDefaultIteratorOperator(genericObject?: GenericObject): IPDIteratorOperatorDTO {
        let itOperator = {
            disablePrincipalFilter: null,
            historizationDates: null,
            includeAllPrincipals: null,
            includeBasePrincipals: null,
            includePrincipalFromSubject: null,
            includeSubPrincipals: null,
            isGridIterator: false,
            memoryOptimizationEnabled: false,
            onlySubPrincipals: null,
            principalFilter: null,
            searchObjectPositionRequest: null,
            showCurrentObjects: null,
            showHistoricedObjects: null,
            showObjectsWithoutPrincipal: null,
            visibleDeletedObjects: null,
            hideConnectedElementsRequest: null,
        };

        if (genericObject != null && genericObject.isHistorized === true) {
            itOperator.historizationDates = [genericObject.historizationDate];
            itOperator.showHistoricedObjects = true;
            itOperator.showCurrentObjects = false;
        }

        return itOperator;
    }
}